import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { ReactComponent as RocketIcon } from "./assets/rocket.svg";

export const AnonymousSelectEntityPlaceholder: React.FC = () => {
  const { t } = useTranslations();

  return (
    <div className="flex h-full min-w-0 items-center justify-center gap-3 px-3 lg:px-6">
      <RocketIcon />
      <span className="min-w-0 truncate font-secondary text-sm font-medium text-white">
        {t({ id: "common.my-workspace", defaultMessage: "My workspace" })}
      </span>
    </div>
  );
};
